import { apiService } from './apiService'
import { ApiResponse } from '../types/partner'
import {
  Contract,
  ContractFile,
  CreateContractRequest,
  UpdateContractRequest,
} from '../types/contracts'

class ContractService {
  // ─── List & detail ──────────────────────────────────────────────

  async list(partnerId: string, params?: { customerId?: string; status?: string }): Promise<ApiResponse<Contract[]>> {
    return apiService.get<Contract[]>(`/partner/${partnerId}/contracts`, params)
  }

  async get(partnerId: string, contractId: string): Promise<ApiResponse<Contract>> {
    return apiService.get<Contract>(`/partner/${partnerId}/contracts/${contractId}`)
  }

  // ─── Mutations ─────────────────────────────────────────────────

  async create(partnerId: string, customerId: string, data: CreateContractRequest): Promise<ApiResponse<Contract>> {
    return apiService.post<Contract>(`/partner/${partnerId}/customer/${customerId}/contracts`, data)
  }

  async update(partnerId: string, contractId: string, data: UpdateContractRequest): Promise<ApiResponse<Contract>> {
    return apiService.put<Contract>(`/partner/${partnerId}/contracts/${contractId}`, data)
  }

  async remove(partnerId: string, contractId: string): Promise<ApiResponse<void>> {
    return apiService.delete<void>(`/partner/${partnerId}/contracts/${contractId}`)
  }

  // ─── Files ─────────────────────────────────────────────────────

  async uploadFile(partnerId: string, contractId: string, file: File): Promise<ApiResponse<ContractFile>> {
    const form = new FormData()
    form.append('file', file)
    const response = await apiService.http.post<ApiResponse<ContractFile>>(
      `/partner/${partnerId}/contracts/${contractId}/files`,
      form,
    )
    return response.data
  }

  async getDownloadUrl(partnerId: string, contractId: string, fileId: string): Promise<ApiResponse<{ url: string; fileName: string }>> {
    return apiService.get<{ url: string; fileName: string }>(`/partner/${partnerId}/contracts/${contractId}/files/${fileId}/download`)
  }

  /** Stream file content through the API (avoids CORS on blob storage). */
  async getFileContent(partnerId: string, contractId: string, fileId: string): Promise<Blob> {
    return apiService.getBlob(`/partner/${partnerId}/contracts/${contractId}/files/${fileId}/content`)
  }

  async deleteFile(partnerId: string, contractId: string, fileId: string): Promise<ApiResponse<void>> {
    return apiService.delete<void>(`/partner/${partnerId}/contracts/${contractId}/files/${fileId}`)
  }
}

export const contractService = new ContractService()
